/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InvitationUpdateByEmergencyContactDto = {
  status: InvitationUpdateByEmergencyContactDto.status;
};
export namespace InvitationUpdateByEmergencyContactDto {
  export enum status {
    ACCEPTED = 'ACCEPTED',
  }
}

